interface Review {
  id: number;
  name: string;
  username: string;
  avatarUrl: string;
  content: string;
  rating: number;
}

const reviews: Review[] = [
  {
    id: 1,
    name: '小猫咪爱吃鱼',
    username: 'user_maomi',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Cute%20minimalist%20cat%20avatar%20illustration%20with%20warm%20peach%20background%2C%20simple%20line%20art%20style%2C%20clean%20design&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '「深渊之花」的画风真的太绝了！每一话都像在看艺术画展，剧情也是层层递进完全不拖沓，已经安利给所有朋友了！',
    rating: 5,
  },
  {
    id: 2,
    name: '漫画老司机',
    username: 'comic_veteran',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20cool%20fox%20avatar%20illustration%20with%20warm%20amber%20background%2C%20simple%20geometric%20style%2C%20clean%20design&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '看韩漫十年了，「武神传说」绝对是我心目中的TOP3。打斗分镜流畅到爆炸，人物塑造也很丰满，推荐所有热血漫爱好者。',
    rating: 5,
  },
  {
    id: 3,
    name: '夜雨声烦',
    username: 'night_rain',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20owl%20avatar%20illustration%20with%20warm%20coral%20background%2C%20simple%20flat%20design%20style%2C%20clean%20modern%20aesthetic&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '每天都要刷一遍更新列表，韩漫漫画的更新速度真的没话说。下拉式阅读体验也很舒服，不需要翻页等加载。',
    rating: 5,
  },
  {
    id: 4,
    name: '春暖花开',
    username: 'spring_bloom',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20rabbit%20avatar%20illustration%20with%20warm%20pink%20background%2C%20cute%20simple%20style%2C%20clean%20design&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '「首尔之恋」让我找回了初恋的感觉~ 画风甜而不腻，男女主的互动太让人心动了。强烈推荐给喜欢甜宠的朋友！',
    rating: 4,
  },
  {
    id: 5,
    name: '追漫达人Leo',
    username: 'leo_comic',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20lion%20avatar%20illustration%20with%20warm%20golden%20background%2C%20simple%20geometric%20style%2C%20clean%20modern%20design&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '网站界面干净整洁没广告弹窗太重要了！下拉式流畅度完爆其他平台，已经把这个漫画网址收藏了，强烈推荐！',
    rating: 5,
  },
  {
    id: 6,
    name: '星月童话',
    username: 'star_moon',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Minimalist%20deer%20avatar%20illustration%20with%20warm%20lavender%20background%2C%20simple%20elegant%20style%2C%20clean%20design&width=80&height=80&seq=avatar-06&orientation=squarish',
    content: '「魔法学园」的世界观太宏大了，每次更新都像打开新世界的大门。免费韩国漫画能有这种品质真的很惊喜！',
    rating: 5,
  },
];

export default function ReviewSection() {
  return (
    <section className="relative bg-background-100 py-14 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="mb-10 md:mb-14">
            <span className="inline-block px-3 py-1 rounded-lg bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              读者评价
            </span>
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              来自漫画迷的真实反馈
            </h2>
            <p className="text-lg md:text-xl text-foreground-600 mt-2">
              阅读体验超出预期
            </p>
          </div>

          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
            {reviews.map((review) => (
              <div
                key={review.id}
                className="break-inside-avoid mb-5 bg-background-50 rounded-lg p-5"
              >
                <div className="flex items-center gap-3 mb-4">
                  <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                    <img
                      src={review.avatarUrl}
                      alt={review.name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground-950">{review.name}</p>
                    <p className="text-xs text-foreground-400">@{review.username}</p>
                  </div>
                </div>
                <div className="flex gap-0.5 mb-3">
                  {Array.from({ length: review.rating }).map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-500 text-xs"></i>
                  ))}
                </div>
                <p className="text-sm text-foreground-700 leading-relaxed">
                  「{review.content}」
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}